import { ReactNode } from 'react'
import ColorSelector from '../../colorSelector/colorSelector'
import { SettingType } from '../drawingTools/drawing.enums'
import { ColorValue, DrawingSettingItem, LineTypes, SettingValues } from '../drawingTools/drawing.interface'
import { Box } from '@mui/material'
import StrokeWidthSelector from './strokeWidthSelector/strokeWidthSelector'
import useStyles from './styles'
import LineTypeSelector from './lineTypeSelector/lineTypeSelector'
import FontSizeSelector from './fontSizeSelector/fontSizeSelector'
import { NonInteractiveTooltip } from '../../custom'

export type ChartMiniSettingsMenuItemProps = {
    id: string,
    setting: DrawingSettingItem<any, SettingValues>,
    value: SettingValues,
    onValueChange: (name: string, value: SettingValues) => void
}

const ChartMiniSettingsMenuItem: React.FC<ChartMiniSettingsMenuItemProps> = ({ setting, value, onValueChange }) => {
    const { classes } = useStyles()
    const { name, type, label } = setting
    let component: ReactNode = <></>
    if (!value) return null
    switch (type) {
        case SettingType.COLOR:
            const onColorChange = (color: string, opacity: number) => {
                onValueChange(name.toString(), {
                    color,
                    opacity
                })
            }
            component =
                <ColorSelector compact color={(value as ColorValue).color} opacity={(value as ColorValue).opacity}
                               onColorChange={onColorChange} />
            break
        case SettingType.STROKE_WIDTH:
            component = <StrokeWidthSelector compact value={value as number} onChange={(value) => {
                onValueChange(name.toString(), value)
            }} />
            break
        case SettingType.LINE_TYPE:
            component = <LineTypeSelector compact value={value as LineTypes} onChange={(value) => {
                onValueChange(name.toString(), value)
            }} />
            break
        case SettingType.FONT:
            component = <FontSizeSelector value={value as number} onChange={(value) => {
                onValueChange(name.toString(), value)
            }} />
            break
    }
    return <NonInteractiveTooltip title={label} arrow={false} placement="top">
        <Box className={classes.miniSettingsMenuItem}>
            {component}
        </Box>
    </NonInteractiveTooltip>
}

export default ChartMiniSettingsMenuItem